<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      width="auto"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          color="primary"
          v-bind="props"
          @click="dialogComputed = true"
        >
        Get Files from SFTP
        </v-btn>
      </template>
      <v-card>
        <v-card-title>Select Files</v-card-title>
        <v-divider></v-divider>
        <v-row class="spacedRow">
      <v-col>
        <v-progress-linear indeterminate v-if="isLoadingData">
        </v-progress-linear>
      </v-col>
    </v-row>
        <v-card-text style="height: 30rem;">
          <!-- Why the list is empty, rather than an empty dialog that looks the same
               whether the server is unreachable or the folder holds nothing. -->
          <div v-if="!isLoadingData && !fileList.length" class="pa-2">
            {{ listMessage }}
          </div>
          <v-radio-group
            v-model="selectedFile"
            column
          >
            <!-- v-for sits on the v-radio itself: the <template> wrapped a single
                 element and bought nothing, while splitting the loop from its key is
                 what the editor flags (its rule is the Vue 3 one - this is Vue 2, where
                 a key on <template v-for> is invalid, so moving it up is not the fix). -->
            <v-radio
              v-for="todo in fileList"
              :key="todo"
              :label="todo"
              :value="todo"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="previewFile"
          >
            Preview
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <TransformMapperPreviewData
      ref="childComponentRef"
      :isImportedData="true"
      @importDataFromFile="importDataFromFile"
    />
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import TransformMapperPreviewData from '@/components/config/TransformMapperPreviewImport.vue';
import { clients } from '@/util/clients/index';
import {
  ftpEmptyMessage,
  ftpErrorMessage,
  readFtpFileList,
  readFtpPath,
} from '@/util/shared/ftp-file-list';

const { backendRest } = clients.direct;

export default {
  components: {
    TransformMapperPreviewData,
  },
  props: {
    pipeline: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selectedFile: undefined,
    dialog: false,
    fileList: [],
    fileData: {},
    isLoadingData: true,
    // Why fileList is empty - a connection error or the folder that was read.
    listMessage: '',
  }),
  created() {
  },
  computed: {
    dialogComputed: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.dialog = value;
        this.fileList = [];
        this.getListFromSftp();
      },
    },
  },
  methods: {
    ...mapActions([
      'flashError',
    ]),
    async getListFromSftp() {
      let response = {};
      const { sftpType } = this.pipeline.customConfig.importProfile;
      this.isLoadingData = true;
      this.listMessage = '';
      try {
        if (sftpType == null) {
          this.listMessage = 'This import profile has no SFTP connection configured.';
          this.fileList = [];
          return;
        }
        response = await backendRest.get(`/sftp/get-import-list?sftpType=${sftpType}`);
        this.fileList = readFtpFileList(response.data).map((r) => r.name);
        if (!this.fileList.length) {
          this.listMessage = ftpEmptyMessage(readFtpPath(response.data));
        }
      } catch (e) {
        console.error(e);
        // The reason the SFTP server gave, not "facing issue" - see TKT-000856.
        this.fileList = [];
        this.listMessage = ftpErrorMessage(e);
        this.flashError(this.listMessage);
      } finally {
        this.isLoadingData = false;
      }
    },
    async previewFile() {
      let response = {};
      this.isLoadingData = true;
      const { sftpType } = this.pipeline.customConfig.importProfile;
      if (this.selectedFile && sftpType != null) {
        try {
          response = await backendRest.get(`/sftp/download-file?filePath=${this.selectedFile}&sftpType=${sftpType}`);
        } catch (e) {
          console.error(e);
          this.flashError('Facing issue while downloading file from SFTP');
        }
      }
      this.fileData = response.data || {};
      this.$refs.childComponentRef.previewImportedData(this.pipeline, this.fileData.parsedData || '');
      this.isLoadingData = false;
    },
    importDataFromFile() {
      this.dialog = false;
      const file = new File([this.fileData.parsedData || ''], this.selectedFile);
      this.$emit('importDataFromFile', file);
    },
  },
};
</script>
